import { memo, ReactNode, useCallback, useState } from 'react';
import cn from 'classnames';
import { Button } from 'antd';

import { HoverInfo } from './HoverInfo';
import styles from './style.module.css';
import { UsersTablet } from '../../../models/Users/Users';
import { UsersRequest } from '../../../store/reducers/UsersSlice';

export interface ExtraProps {
  selectedClinics?: string[];
  selectedScenario?: string | null;
  selectedResults?: string[];
  selectedBatchIds?: string[];
  startDate?: string;
  endDate?: string;
  icon?: ReactNode;
  hoveredText?: string;
  isEditing?: boolean;
  selectedUser?: UsersTablet;
  callRequest?: UsersRequest;
  onSuccess?: () => void;
}

interface PopupRenderProps {
  open: boolean;
  onClose: () => void;
  blockNumberInfo?: {
    useForInboing: boolean;
    useForOutbound: boolean;
    phone: string;
    fullName: string;
  };
  extra?: ExtraProps;
}

interface Props {
  title: string;
  isSquared?: boolean;
  PopupComponent: React.ComponentType<PopupRenderProps>;
  blockNumberInfo?: {
    useForInboing: boolean;
    useForOutbound: boolean;
    phone: string;
    fullName: string;
  };
  extra?: ExtraProps;
  ariaLabel?: string;
  isWide?: boolean;
  isTableButton?: boolean;
  disabled?: boolean;
}

export const ButtonPopup = memo(
  ({
    title,
    isSquared,
    PopupComponent,
    blockNumberInfo,
    extra,
    ariaLabel,
    isWide,
    isTableButton,
    disabled = false,
  }: Props) => {
    const [open, setOpen] = useState(false);
    const [hoveredStatus, setHoveredStatus] = useState(false);

    const handleShowModal = useCallback(() => {
      setOpen(true);
    }, [setOpen]);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
      <div className={styles.buttonPopup}>
        <Button
          type={isTableButton ? 'default' : 'primary'}
          variant={isTableButton ? 'text' : 'solid'}
          onClick={handleShowModal}
          className={cn(
            styles.button,
            isSquared ? styles.buttonSquared : '',
            isWide ? styles.buttonWide : '',
          )}
          icon={extra?.icon}
          aria-label={ariaLabel}
          disabled={disabled}
          onMouseEnter={() => setHoveredStatus(true)}
          onMouseLeave={() => setHoveredStatus(false)}
        >
          {title}
        </Button>
        {blockNumberInfo ? (
          <PopupComponent
            open={open}
            onClose={handleClose}
            blockNumberInfo={blockNumberInfo}
          />
        ) : (
          <PopupComponent open={open} onClose={handleClose} extra={extra} />
        )}
        {hoveredStatus && extra?.hoveredText && (
          <HoverInfo text={extra.hoveredText} />
        )}
      </div>
    );
  },
);

ButtonPopup.displayName = 'ButtonPopup';
